import React from 'react'
//import previaje from '../../imagenes/checkout/payment-options/previaje.png'

const Reintegros = (props) => {

  window.scrollTo(0,0);

  return (
    <section className="sobre-pedraza condiciones-contratacion">

      <div className="container">
        <div className="row">
          <article className="txt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div><img style={{width: '100%'}} src="https://pedraza.com.ar/assets/img/paquetes/bg/previaje.jpg" alt="Logo de Previaje"/></div>
            <br />
            <h1>Programa de preventa tur&iacute;stica "Previaje 5"</h1>

            <hr />
            <h6>¿Cómo funciona?</h6>
            <p>Por cada compra de servicios turísticos para viajar por Argentina, recibirás un crédito del 50% y del 70% para jubilados de PAMI, para gastarlo en servicios turísticos.</p>

            <h6>Fechas de compra y viaje:</h6>
            <ul>
              <li>- PARA VIAJAR DEL 29 DE SEPTIEMBRE AL 17 DE OCTUBRE: Son válidas las compras del 1 al 7 de septiembre y el plazo para cargar tus comprobantes  del 1 al 8 de septiembre. (*)</li>
              <li>- Las compras en Pedraza Viajes y Turismo generan un crédito del 50% o del 70% para jubilados de PAMI, con un monto de reintegro de hasta $100.000.</ li>
              <li>- El total del crédito va a estar disponible a partir de la fecha de inicio del viaje.</li>
              <li>- Si cuando volvés de tu viaje te sobra crédito, podés gastarlo en el sector turístico  hasta el 31/10/23.</li>
            </ul>
            
            <br />

            <h6>A TENER EN CUENTA</h6>
            <ul>
              <li>- No se aceptan compras en efectivo.</li>
              <li>- Los servicios se deben abonar mediante tarjeta de débito y/o crédito, pago electrónico, billetera virtual o transferencia bancaria.</li>
              <li>- Asegúrate de conservar los comprobantes de acreditación del pago.</li>
            </ul>

            <p>(*) Las fechas de compra y de carga de comprobantes están sujetas a cambios que serán informados por el Ministerio de Turismo y Deportes de la Nación, en el caso de que se alcance con antelación el presupuesto destinado a este programa.</p>

            <h5>IMPORTANTE!!!</h5>
            <p><strong>Los comprobantes para aquellos clientes que reserven mediante la web, deberán solicitarlos a través de la misma plataforma y serán recibido mediante el correo electrónico registrado y también subidos a su perfil. Aquellos que reserven de manera telefónica, whats app, redes sociales o presencialmente en nuestras oficinas, lo recibirán en su correo electrónico. Para todos los casos la emisión del mismo podrá demorar entre 24 y 48hs luego de efectuado el pago total de la reserva.</strong></p>
          </article>
        </div>
      </div>
    </section>

  )
}

export default Reintegros



// WEBPACK FOOTER //
// ./src/components/Global/Reintegros.js